import * as React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as automationLabels from '@Utils/facade/edgeTs/automationLabels';
import useWidget from '@Utils/core/useWidget';
import { WidgetId } from '@Utils/edge/constants';
import useMediaQuery from '@Utils/core/hooks/useMediaQuery-v3';
import useDefineDevice from '@Utils/core/hooks/useDefineDevice';
import * as Styled from '../Nickname.styled';
import GeneratorContext from '../../../GeneratorContext';

interface OwnProps {
  setIsCopied: (arg: boolean) => void;
}

const CopyButton: ReactFCWithChildren<OwnProps> = (props) => {
  const widgetGeneratorGlobalV3 = useWidget(WidgetId.GeneratorGlobalV3);
  const { isTouchDevice } = useDefineDevice();
  const { isMobileOrTablet } = useMediaQuery();
  const context = React.useContext(GeneratorContext);

  const handleCopy = () => {
    props.setIsCopied(true);
  };

  return (
    <CopyToClipboard text={context.generatedNickname} onCopy={handleCopy}>
      <Styled.CopyButton
        isTouchDevice={isTouchDevice}
        {...automationLabels.getProps('generate.copyLink.button')}
      >
        <Styled.CopyIcon />
        {!isMobileOrTablet ? (
          <Styled.Popover>{widgetGeneratorGlobalV3.strings.copyButton}</Styled.Popover>
        ) : null}
      </Styled.CopyButton>
    </CopyToClipboard>
  );
};

export default CopyButton;
